import { reactive, toRefs, provide, inject, computed } from "@vue/composition-api";

export const state = reactive({
    loading_tree: {},
    loading: {}
});

export const useLoading = module_name => {
    state.loading_tree = Object.assign({}, state.loading_tree, { [module_name]: []});
    const startLoading = func_name => {
        state.loading_tree[module_name] = Object.assign({}, state.loading_tree[module_name], { [func_name]: true });
        state.loading = Object.assign({}, state.loading, { [func_name]: true });
    };
    const finishLoading = func_name => {
        const updated_module = Object.assign({}, state.loading_tree[module_name], { [func_name]: false });
        state.loading_tree = Object.assign({}, state.loading_tree, { [module_name]: updated_module });
        state.loading = Object.assign({}, state.loading, { [func_name]: false });
    };
    return {
        startLoading,
        finishLoading
    };
};

export const getters = {
    anyLoading: computed(() => {
        // console.log("anyloading", Object.keys(state.loading).any(val => !!val));
        return Object.keys(state.loading).any(val => !!val);
    }),
    loadingByModule: module_name =>
        computed(() => {
            return Object.keys(state.loading_tree[module_name]).any(val => !!val);
        })
};

export const key = Symbol("LoadingModule");

export const provideLoading = () =>
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...useLoading
    });

export default () => inject(key);
